import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductsDesktop.css";

import PaintBlueBG from "../assets/paintblue-bg.png";
import PaintBlue from "../assets/paintblue.png";
import PaintPinkBG from "../assets/paintpink-bg.png";
import PaintPink from "../assets/paintpink.png";
import PaintNavyBG from "../assets/paintNavy-bg.png";
import PaintNavy from "../assets/paintNavy3.png";
import PaintCyanBG from "../assets/paintCyan-bg.png";
import PaintCyan from "../assets/paintCyan.png";
import PaintRedBG from "../assets/paintRed-bg.png";
import PaintRed from "../assets/paintRed.png";
import PaintYellowBG from "../assets/paintYellow-bg.png";
import PaintYellow from "../assets/paintYellow.png";
import lifestyleImg from "../assets/lifestyleImg.png";
import PaletteImg from "../assets/paletteImg2.png";
import ShadesImgBG from "../assets/shadesImg-bg.png";
import CategoryImgBG from "../assets/categoryImg-bg.png";
import GreenBucketBG from "../assets/greenBucket-bg.png";
import GreenBucket from "../assets/greenBucket.png";

export default function ProductsDesktop() {
  const navigate = useNavigate();

  const openProduct = (productId) => {
    navigate(`/products/${productId}`);
  };

  const handleCardKeyDown = (event, productId) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openProduct(productId);
    }
  };

  return (
    <section className="products">
      {/* === HEADER SECTION === */}
      <div className="products-header">
        <h2>Our Products</h2>
        <p>Pakistan’s Top Choice in Locally Manufactured Paints</p>
      </div>
      <p className="products-t">
        Glamur Paint is a premium Pakistan-based brand dedicated to transforming
        spaces with quality, innovation, and style. Proudly manufactured in
        Pakistan, our paints are designed to meet the highest standards of
        durability and aesthetics, ensuring a lasting impression in every room.
      </p>

      {/* === ROW 1 & 2: MAIN PRODUCTS GRID === */}
      <div className="products-grid">
        {/* Product Card - Plastic Emulsion (Blue) */}
        <div
          className="box hover-card product-clickable"
          style={{ backgroundImage: `url(${PaintBlueBG})` }}
          onClick={() => openProduct(1)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => handleCardKeyDown(event, 1)}
        >
          <img src={PaintBlue} alt="Plastic Emulsion Paint Bucket" />
          <div className="card-content">
            <h3>Plastic Emulsion</h3>
            <p>
              Plastic Emulsion is your everyday hero soft to the touch, smooth
              in finish, and effortlessly elegant. It glides onto walls like
              poetry, leaving behind a breathable coat that feels fresh and
              refined.
            </p>
            {/* <a href="#"> <img src={arrowIcon} alt="arrow" className="arrow-icon" /></a> */}
          </div>
        </div>

        {/* Product Card - Plastic Emulsion (Pink) */}
        <div
          className="box hover-card product-clickable"
          style={{ backgroundImage: `url(${PaintPinkBG})` }}
          onClick={() => openProduct(5)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => handleCardKeyDown(event, 5)}
        >
          <img src={PaintPink} alt="Plastic Emulsion Paint Bucket" />
          <div className="card-content">
            <h3>Aquatic Matt Emulsion</h3>
            <p>
              Aquatic Matt Emulsion is where top-tier craftsmanship meets subtle
              elegance. This water based formula delivers a rich, matte finish
              that feels both modern and timeless.
            </p>
            {/* <a href="#"> <img src={arrowIcon} alt="arrow" className="arrow-icon" /></a> */}
          </div>
        </div>

        {/* Palette Image (Tall Card) */}
        <div className="box tall">
          <img src={PaletteImg} alt="Color Palette" />
        </div>

        {/* Browse Shade Cards - Wide Section */}
        <div className="box wide highlight">
          <img src={ShadesImgBG} alt="Shade Cards" />
          <div className="overlay"></div>

          {/* Overlay Text + Button */}
          <div className="shade-text-box">
            <h2>Browse Our Shade Cards</h2>
            <p>
              Take the guesswork out of painting. Our curated shade cards help
              you explore colour families, combinations, and trending tones.
            </p>
            <button className="shade-btn">VIEW ALL SHADES</button>
          </div>
        </div>

        {/* Weather Guard - Side Card */}
        <div
          className="box hover-side-card product-clickable"
          style={{ backgroundImage: `url(${PaintNavyBG})` }}
          onClick={() => openProduct(6)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => handleCardKeyDown(event, 6)}
        >
          <div className="product-image">
            <img src={PaintNavy} alt="Weather Guard Paint" />
          </div>
          <div className="side-info">
            <h3>Weather Guard</h3>
            <p>
              Weather Guard stands tall against the elements. From blistering
              sun to monsoon rains, it shields your home with unwavering
              resilience. Its tough exterior finish resists fading, cracking,
              and peeling keeping your walls bold and beautiful through every
              season.
            </p>
            {/* <a href="#"> <img src={arrowIcon} alt="arrow" className="arrow-icon" /></a> */}
          </div>
        </div>
      </div>

      {/* === ROW 3: CYAN / RED STACK + CATEGORY CARD + YELLOW CARD === */}
      <div className="col-3">
        {/* Left Column - Two Stacked Product Cards */}
        <div className="left-stack">
          {/* Plastic Emulsion (Cyan) */}
          <div
            className="box hover-card product-clickable"
            style={{ backgroundImage: `url(${PaintCyanBG})` }}
            onClick={() => openProduct(7)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => handleCardKeyDown(event, 7)}
          >
            <img src={PaintCyan} alt="Plastic Emulsion Paint Bucket" />
            <div className="card-content2">
              <h3>Aquatic Wall Sealer</h3>
              <p>
                Before the beauty begins, Aquatic Wall Sealer lays the
                foundation. It penetrates deep, locking out moisture and locking
                in strength. With superior adhesion and a painter’s ease, it
                prepares your surface for lasting brilliance.
              </p>
              {/* <a href="#"> <img src={arrowIcon} alt="arrow" className="arrow-icon" /></a> */}
            </div>
          </div>

          {/* Plastic Emulsion (Red) */}
          <div
            className="box hover-card product-clickable"
            style={{ backgroundImage: `url(${PaintRedBG})` }}
            onClick={() => openProduct(2)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => handleCardKeyDown(event, 2)}
          >
            <img src={PaintRed} alt="Plastic Emulsion Paint Bucket" />
            <div className="card-content2">
              <h3>High Class Emulsion</h3>
              <p>
                High Class Emulsion is luxury in liquid form. Rich in texture,
                radiant in finish, it transforms ordinary spaces into elegant
                expressions. Washable, durable, and deeply refined, it’s made
                for those who see walls as part of their story.
              </p>
              {/* <a href="#"> <img src={arrowIcon} alt="arrow" className="arrow-icon" /></a> */}
            </div>
          </div>
        </div>

        {/* Middle Column - Category Card */}
        <div className="box middle">
          <img src={CategoryImgBG} alt="Paint Category" />
          <div className="overlay category-text-box">
            <h2>Choose your paint category</h2>
            <p>
              Explore our premium paint categories and find the perfect shade to
              bring elegance and style to every space.
            </p>
            <button
              className="category-btn"
              onClick={() => navigate("/e-store")}
            >
              VIEW ALL PRODUCTS
            </button>
          </div>
        </div>

        {/* Right Column - Yellow Card */}
        <div className="boxtall">
          <div
            className="box hover-card product-clickable"
            style={{ backgroundImage: `url(${PaintYellowBG})` }}
            onClick={() => openProduct(3)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => handleCardKeyDown(event, 3)}
          >
            <img src={PaintYellow} alt="Plastic Emulsion Paint Bucket" />
            <div className="card-content3">
              <h3>Wall Putty</h3>
              <p>
                Wall Putty is the sculptor’s touch smoothing cracks, leveling
                surfaces, and creating the perfect canvas. It spreads like silk,
                dries with strength, and sets the stage for flawless finishes.
              </p>
              {/* <a href="#"> <img src={arrowIcon} alt="arrow" className="arrow-icon" /></a> */}
            </div>
          </div>
        </div>
      </div>

      {/* === ROW 4: LIFESTYLE IMAGE + GREEN BUCKET CARD === */}
      <div className="col-4">
        {/* Lifestyle Full-Width Image */}
        <div className="box full">
          <img src={lifestyleImg} alt="Lifestyle" />
        </div>

        {/* Green Bucket Card */}
        <div
          className="box hover-card product-clickable"
          style={{ backgroundImage: `url(${GreenBucketBG})` }}
          onClick={() => openProduct(4)}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => handleCardKeyDown(event, 4)}
        >
          <img src={GreenBucket} alt="Plastic Emulsion Paint Bucket" />
          <div className="card-content4">
            <h3>Gloss Enamel</h3>
            <p>
              Gloss Enamel is bold, brilliant, and built to last. Its mirror
              like shine adds charm to doors, windows, and metal surfaces, while
              its tough formula resists wear and tear.
            </p>
            {/* <a href="#"> <img src={arrowIcon} alt="arrow" className="arrow-icon" /></a> */}
          </div>
        </div>
      </div>
    </section>
  );
}
